import {
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_HALL,
    OBJECT_TYPE_RECTANGLE_TABLE,
    OBJECT_TYPE_ROUND_TABLE,
    OBJECT_TYPE_ROW,
    OBJECT_TYPE_SEAT,
    OBJECT_TYPE_SECTOR,
    OBJECT_TYPE_SHAPE,
} from '%paysera_seat_selection/js/seatSelection/config/constants';

function getClosestConfigurationFromHall(hall) {
    return hall.configuration;
}

function getClosestConfigurationFromSector(sector, branchName) {
    if (sector.configuration && sector.configuration[branchName]) {
        return sector.configuration;
    }

    return getClosestConfigurationFromHall(sector.hall);
}

function getClosestConfigurationFromRoundTable(table, branchName) {

    if (table === null) {
        return null;
    }

    if (table.configuration && table.configuration[branchName]) {
        return table.configuration;
    }

    return getClosestConfigurationFromHall(table.hall);
}

function getClosestConfigurationFromRectangleTable(table, branchName) {
    if (table.configuration && table.configuration[branchName]) {
        return table.configuration;
    }

    return getClosestConfigurationFromHall(table.hall);
}

function getClosestConfigurationFromGeneralAdmission(generalAdmission, branchName) {
    if (generalAdmission.configuration && generalAdmission.configuration[branchName]) {
        return generalAdmission.configuration;
    }

    return getClosestConfigurationFromHall(generalAdmission.hall);
}

function getClosestConfigurationFromShape(shape, branchName) {
    if (shape.configuration && shape.configuration[branchName]) {
        return shape.configuration;
    }

    return getClosestConfigurationFromHall(shape.hall);
}

function getClosestConfigurationFromRow(row, branchName) {
    if (row.configuration && row.configuration[branchName]) {
        return row.configuration;
    }

    return getClosestConfigurationFromSector(row.sector, branchName);
}

function getClosestConfigurationFromSeat(seat, branchName) {
    if (seat.configuration && seat.configuration[branchName]) {
        return seat.configuration;
    }

    if (seat.row) {
        return getClosestConfigurationFromRow(seat.row, branchName);
    }
    if (seat.roundTable) {
        return getClosestConfigurationFromRoundTable(seat.roundTable, branchName);
    }
    if (seat.rectangleTable) {
        return getClosestConfigurationFromRectangleTable(seat.rectangleTable, branchName);
    }

    throw new Error('No such configuration in Seat');
}

function getClosestConfigurationByObjectType(object, branchName) {
    const { objectType } = object;
    if (objectType === OBJECT_TYPE_HALL) {
        return getClosestConfigurationFromHall(object);
    }
    if (objectType === OBJECT_TYPE_SECTOR) {
        return getClosestConfigurationFromSector(object, branchName);
    }
    if (objectType === OBJECT_TYPE_ROW) {
        return getClosestConfigurationFromRow(object, branchName);
    }
    if (objectType === OBJECT_TYPE_SEAT) {
        return getClosestConfigurationFromSeat(object, branchName);
    }
    if (objectType === OBJECT_TYPE_GENERAL_ADMISSION) {
        return getClosestConfigurationFromGeneralAdmission(object, branchName);
    }
    if (objectType === OBJECT_TYPE_RECTANGLE_TABLE) {
        return getClosestConfigurationFromRectangleTable(object, branchName);
    }
    if (objectType === OBJECT_TYPE_ROUND_TABLE) {
        return getClosestConfigurationFromRoundTable(object, branchName);
    }
    if (objectType === OBJECT_TYPE_SHAPE) {
        return getClosestConfigurationFromShape(object, branchName);
    }

    throw new Error(`No configuration for such object: ${objectType}`);
}

export {
    getClosestConfigurationByObjectType,
    getClosestConfigurationFromRow,
    getClosestConfigurationFromSector,
    getClosestConfigurationFromHall,
    getClosestConfigurationFromSeat,
    getClosestConfigurationFromRoundTable,
    getClosestConfigurationFromRectangleTable,
    getClosestConfigurationFromGeneralAdmission,
    getClosestConfigurationFromShape,
};
